module.exports = __webpack_public_path__ + "img/loading-2.fe3e38fb.gif";